/*
* @Author: gujianghua
* @Date:   2018-06-27 10:57:46
* @Last Modified by:   gujianghua
* @Last Modified time: 2020-05-19 20:32:51
*/
import {uid} from '@/utils/random'
const tabs = {
	namespaced: true,

	state: {
		tabList: [],
		tabActive: {
			code: 'home',
			name: 'home',
			root: 'home',
			item: ''
		},
		defaultMenuList: []
	},

	getters: {
		tabList: state => {
			return state.tabList
		},
		tabActive: state => {
			return state.tabActive
		},
		getDefaultMenuList: state => {
			return state.defaultMenuList
		}
	},

	actions: {
		addTab ({ commit }, val) {
			return new Promise((resolve, reject) => {
				commit('add', val)
				resolve()
			}).catch(error => {
				console.log(error)
				reject(error)
			})
		},
		removeTab ({ commit }, val) {
			return new Promise((resolve, reject) => {
				commit('remove', val)
				resolve()
			}).catch(error => {
				console.log(error)
				reject(error)
			})
		},
		removeAllTabs ({ commit }, val) {
			return new Promise((resolve, reject) => {
				commit('removeAll', val)
				resolve()
			}).catch(error => {
				console.log(error)
				reject(error)
			})
		},
		removeOtherTabs ({ commit }, val) {
			return new Promise((resolve, reject) => {
				commit('removeOther', val)
				resolve()
			}).catch(error => {
				console.log(error)
				reject(error)
			})
		},
		removeRightTabs ({ commit }, val) {
			return new Promise((resolve, reject) => {
				commit('removeRight', val)
				resolve()
			}).catch(error => {
				console.log(error)
				reject(error)
			})
		},
		removeLeftTabs ({ commit }, val) {
			return new Promise((resolve, reject) => {
				commit('removeLeft', val)
				resolve()
			}).catch(error => {
				console.log(error)
				reject(error)
			})
		},
		changeTab ({ commit }, val) {
			return new Promise((resolve, reject) => {
				commit('change', val)
				resolve()
			}).catch(error => {
				console.log(error)
				reject(error)
			})
		},
		switchTab_single ({ commit }, val) {
			return new Promise((resolve, reject) => {
				commit('switch', val)
				resolve()
			}).catch(error => {
				console.log(error)
				reject(error)
			})
		},
		switchTab_more ({ commit }, val) {
			return new Promise((resolve, reject) => {
				commit('switchMore', val)
				resolve()
			}).catch(error => {
				console.log(error)
				reject(error)
			})
		},
		removeSpecifiedTab ({ commit }, code) {
			return new Promise((resolve, reject) => {
				commit('removeSpecified',code)
				resolve()
			}).catch(error => {
				console.log(error)
				reject(error)
			})
		},
		toTargetTab ({ commit }, code) {
			return new Promise((resolve, reject) => {
				commit('toTarget',code)
				resolve()
			}).catch(error => {
				console.log(error)
				reject(error)
			})
		},
		setDefaultMenuList ({ commit }, val) {
			return new Promise((resolve, reject) => {
				commit('setDefaultMenuList', val)
				resolve()
			}).catch(error => {
				console.log(error)
				reject(error)
			})
		}
	},

	mutations: {
		// 增加tab
		add (state, val) {
			val.id = uid()
			state.tabList.push(val)
		},
		// 通过index删除tab
		remove (state, val) {
			removeFunc(state, val)
		},
		// 删除所有tabs
		removeAll (state) {
			state.tabList = []
			state.tabActive = {
				code: 'home',
				name: 'home',
				root: 'home',
				item: ''
			}
		},
		// 通过index删除其他tab
		removeOther (state, val) {
			state.tabList = [state.tabList[val]]
			state.tabActive = state.tabList[0]
		},
		// 删除右侧tab
		removeRight (state, val) {
			state.tabList = state.tabList.slice(0,val+1)
			state.tabActive = state.tabList[val]
		},
		// 删除左侧tab
		removeLeft (state, val) {
			state.tabList = state.tabList.slice(val)
			state.tabActive = state.tabList[0]
		},
		// 改变tab
		change (state, val) {
			state.tabActive = val
		},
		//改变并增加单个tab
		switch (state, data) {
			//使用code判断唯一性
			let hasFind = false
			state.tabList.findIndex(function(val, index) {
				if(val && val.code == data.code){
					hasFind = true
					// code重复则更新
					let mid = {id: state.tabList[index].id}
					mid = Object.assign(mid, data)
					state.tabList[index] = mid
					state.tabActive = mid
				}
			})
			if(hasFind){ return }
			data.id = uid()
			state.tabActive = data
			state.tabList.push(data)
		},
		//改变并增加多个tab
		switchMore (state, val) {
			val.id = uid()
			state.tabList.push(val)
			state.tabActive = val
		},
		//通过code删除tab
		removeSpecified (state, code) {
			if(JSON.stringify(state.tabList).indexOf(code) == -1){
				console.log('不存在该code的tab!')
				return;
			}
			state.tabList.findIndex(function(val, index) {
				if(val && val.code == code){
					removeFunc(state, index)
				}
			})
		},
		/*去指定tab,该tab未打开就去最后一个*/
		toTarget (state, code) {
			if(JSON.stringify(state.tabList).indexOf(code) == -1){
				console.log('不存在该code的tab!')
				return;
			}
			state.tabList.findIndex(function(val, index) {
				if(val && val.code == code){
					state.tabActive = state.tabList[index]
				}
			})
		},
		setDefaultMenuList (state, val) {
			state.defaultMenuList = val
		}
	}
}

function removeFunc (state, val) {
	if(state.tabList.length <= 1){
		// 只剩一个标签
		state.tabActive = {
			code: 'home',
			name: 'home',
			root: ''
		}
		state.tabList.splice(val,1)
		return
	}else if(state.tabActive.code == state.tabList[val].code){
		// 关闭高亮的标签
		state.tabList.splice(val,1)
		state.tabActive = state.tabList[state.tabList.length-1]
		return
	}
	// 正常关闭非高亮标签
	state.tabList.splice(val,1)
}

export default tabs


// WEBPACK FOOTER //
// ./src/store/modules/tabs/index.js